const UNCATEGORIZED_COLOR = '#9aa5a8';

const PALETTE = [
  '#3BB586', '#4f8ef7', '#f5a524', '#e5484d', '#8e4ec6', '#12a594',
  '#e93d82', '#a18072', '#5b6ee1', '#d6a417', '#2fa3cc', '#7ba04b',
];

/** Same category id -> same colour on every screen. */
export function categoryColor(id: string): string {
  if (id === 'uncategorized') return UNCATEGORIZED_COLOR;
  let hash = 0;
  for (let i = 0; i < id.length; i += 1) hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}

export type Trend = { dir: 'up' | 'down' | 'flat' | 'new'; pct: number | null };

/** Change of `current` against the previous period of equal length. */
export function trend(current: number, previous: number): Trend {
  if (previous === 0) return current === 0 ? { dir: 'flat', pct: 0 } : { dir: 'new', pct: null };
  if (current === previous) return { dir: 'flat', pct: 0 };
  const pct = Math.round((Math.abs(current - previous) / previous) * 100);
  return { dir: current > previous ? 'up' : 'down', pct };
}

/** 0.1234 -> "12.3%", 0.5 -> "50%". */
export function formatShare(share: number): string {
  return `${Number((share * 100).toFixed(1))}%`;
}
